import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {AxiosError} from "axios";
import {ICreatePublicationParams, ISInglePublicationsResponseData} from "../models/SinglePublicationsResponse.ts";
import {PublicationService} from "../services/singlePublication-service.ts";
import {setPublication_id, successToastify} from "../../utils/Utils.ts";
import {getPostTC, postActions} from "./post-reducer.ts";
import {NavigateFunction} from "react-router-dom";
import {PublicationStatus} from "../../constants/enums.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";
import {t} from "i18next";

type  InitialStateType = {
    data: ISInglePublicationsResponseData[] | null
    currentPublication: ISInglePublicationsResponseData | null
    isLoading: boolean
    reloadState: boolean
    checkedChannels: boolean
};

const initialState: InitialStateType = {
    data: null,
    currentPublication: null,
    isLoading: false,
    reloadState: false,
    checkedChannels: false,
}

const slice = createSlice({
    name: "publications",
    initialState: initialState,
    reducers: {
        setPublicationData: (state: InitialStateType, action: PayloadAction<ISInglePublicationsResponseData[]>) => {
            state.data = action.payload
        },
        updatePublicationStatus: (state: InitialStateType, action: PayloadAction<PublicationStatus>) => {
            if (state.currentPublication) {
                state.currentPublication.status = action.payload
            }
        },
        setCurrentPublication: (state: InitialStateType, action: PayloadAction<ISInglePublicationsResponseData>) => {
            state.currentPublication = action.payload
        },
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload
        },
        changeReloadState: (state, action: PayloadAction<boolean>) => {
            state.reloadState = action.payload;
        },
        setCheckedChannels: (state, action: PayloadAction<boolean>) => {
            state.checkedChannels = action.payload;
            showCustomErrorToast(t('formValidation.minChannel'), "main", "bottom-center")
        },
    },
});
export const publicationReducer = slice.reducer;
export const publicationActions = slice.actions;

export const getPublicationTC = (id: string, navigate: NavigateFunction, successTitle: string, errTitle: string): AppThunk<Promise<ISInglePublicationsResponseData | void>> =>
    async (dispatch) => {
        dispatch(publicationActions.setIsLoading(true));
        dispatch(postActions.setPostdata(null))
        try {
            const res = await PublicationService.fetchPublicationData(id);
            dispatch(publicationActions.setCurrentPublication(res.data))
            if (res.data.post_id) {
                await dispatch(getPostTC(res.data.post_id))
                    .then(() => {
                        navigate('/channel_info');
                        successToastify(successTitle, 'bottom-center', 'main');
                        dispatch(publicationActions.changeReloadState(true));
                    })
            } else {
                dispatch(publicationActions.changeReloadState(false));
            }
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(errTitle, 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(publicationActions.setIsLoading(false));
        }
    };


export const setPublicationsTC = (id: string): AppThunk<Promise<ISInglePublicationsResponseData[] | void>> =>
    async (dispatch) => {
        dispatch(publicationActions.setIsLoading(true));
        try {
            const res = await PublicationService.fetchPublications(id);
            dispatch(publicationActions.setPublicationData(res.data))
            dispatch(publicationActions.setIsLoading(false));
        } catch
            (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(publicationActions.setIsLoading(false));
        }
    }

;export const updatePublicationStatusTC = (id: string, params: PublicationStatus, successTitle: string, errTitle: string): AppThunk<Promise<ISInglePublicationsResponseData[] | void>> =>
    async (dispatch) => {
        // dispatch(publicationActions.setIsLoading(true));
        try {
            await PublicationService.updatePublication(id, {status: params});
            dispatch(publicationActions.updatePublicationStatus(params));
            successToastify(successTitle, 'bottom-center', 'main');

            // dispatch(publicationActions.setIsLoading(false));
        } catch
            (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(errTitle, 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(publicationActions.setIsLoading(false));
        }
    }
;

export const createPublicationTC = (params: ICreatePublicationParams): AppThunk<Promise<ISInglePublicationsResponseData | void>> =>
    async (dispatch) => {
        dispatch(publicationActions.setIsLoading(true));
        try {
            const res = await PublicationService.createPublication(params);
            dispatch(publicationActions.setCurrentPublication(res.data))
            setPublication_id(res.data.id)
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center')
            throw err;
        } finally {
            dispatch(publicationActions.setIsLoading(false));
        }
    };
